import { createFileRoute } from '@tanstack/react-router';

import { assertUuidRouteParams } from '../../../lib/assert-uuid-route-params.js';
import { SalesOrderReturnReceivePage } from '../../../modules/receiving/sales-order-return-receive-page.js';

export const Route = createFileRoute('/receiving/returns/$salesOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: SalesOrderReturnReceiveRoute,
});

// eslint-disable-next-line react-refresh/only-export-components -- the route's component is private to this file
function SalesOrderReturnReceiveRoute() {
  const { salesOrderId } = Route.useParams();
  return <SalesOrderReturnReceivePage salesOrderId={salesOrderId} />;
}
